import { Status } from '~/components/molecules/Status'
import { useToken } from './hooks'

export const InvalidRequestScreen = () => {
  const { title, content } = useToken()

  return <Status type="error" title={title} content={content} />
}
